(function () {
	const initSlider = () => {
		let productSlider;
		const productSliders = document.querySelectorAll('.blog__posts-swiper');

		productSliders.forEach((slider, index) => {
			// Find the pagination element specific to this slider
			const sectionElement = slider.closest('.section-featured-blog');
			const paginationEl = slider.querySelector('.swiper-pagination') || (sectionElement ? sectionElement.querySelector('.swiper-pagination') : null);
			
			productSlider = new Swiper(slider, {
				pagination: {
					el: paginationEl,
					bulletClass: 'swiper-bullet',
					bulletActiveClass: 'swiper-bullet-active',
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' + this.el.getAttribute('data-duration') + 's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>';
					}
				},
                slidesPerView: 1.6,
                slidesPerGroup: 1,
                spaceBetween: 8,
				autoplay: true,
				on: {
					slideChange: function() {
						this.pagination.render();
						this.pagination.update();
					}
				}
			});
		});
	};

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.blog__posts-swiper');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.section-featured-blog');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();
